import { Button, Drawer, Form } from 'antd';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { PermissionBanners } from '../../../../permissions/PermissionBanners';
import { PermissionCategories } from '../../../../permissions/PermissionCategories';
import bannerStore from '../../../../stores/bannerStore';
import categoryStore from '../../../../stores/categoryStore';
import componentsStore from '../../../../stores/componentsStore';
import homeStore from '../../../../stores/homeStore';
import { convertToDayjs, formattedDates } from '../../../../utils/functions';
import { ComponentesSelect, ResponsiveString, YesOrNot } from '../../../../utils/selects';
import DatePickerRangeComponet from '../../../atoms/DatePickerRangeComponet';
import InputComponent from '../../../atoms/InputComponet';
import InputNumberComponente from '../../../atoms/InputNumberComponet';
import SelectComponent from '../../../atoms/SelectComponent';
import Permission from '../../../molecules/Permission';
import { validationSchemaBanner, validationSchemaCategory } from './schema';

interface DrawerComponentProps {
    isModalDrawer?: boolean;
    setIsDrawerOpen: Dispatch<SetStateAction<boolean | undefined>>;
    homeProps: any;
}

const DrawerComponent: React.FC<DrawerComponentProps> = observer(({ isModalDrawer, setIsDrawerOpen, homeProps }: any) => {
    const [typeSelected, setTypeSelected] = useState<any>();
    const [selectedComponent, setSelectedComponent] = useState<any>();
    const { componentProps } = componentsStore;
    const { bannerListSelected } = bannerStore;
    const { selectCategory } = categoryStore;

    const paramsDefault = {
        "size": 20,
        "page": 0,
        "sort": "created,desc",
        "search": ""
    }

    useEffect(() => {
        setTypeSelected(homeProps?.type)
    }, [homeProps])

    const handleSubmit = async (values: any) => {
        const formattedDate = formattedDates(values?.date, 'YYYY-MM-DD');
        const dateInitial = formattedDate[0];
        const dateFinal = formattedDate[1];

        const createProps = {
            type: values?.type?.value,
            name: values?.name,
            order: values.order,
            mobile: values?.mobile?.value === 'true' ? true : false,
            app: values.mobile?.value === 'true' ? true : false,
            banners: [{
                uuid: values?.banners?.value
            }],
            category: {
                uuid: values?.category?.value
            },
            minDate: `${dateInitial}T00:00:00`,
            maxDate: `${dateFinal}T23:59:59`,
            active: values.active.value === 'true' ? true : false,
            uuid: componentProps?.uuid,
        }

        if (values?.type?.value === "BANNER_CAROUSEL") {
            //@ts-ignore
            delete createProps.category
        }

        if (values?.type?.value === "PRODUCT_CAROUSEL") {
            //@ts-ignore
            delete createProps?.banners
        }

        const response = await componentsStore.editComponent(createProps, homeProps.uuid);

        if (!response.error) {
            await componentsStore.getList(paramsDefault);
        }

        const addComponent = {
            order: response.order,
            mobile: response.mobile,
            componentUuid: response,
            component: response,
            screen: true,
        }

        if (!response.erro) {
            await homeStore.addComponent(addComponent);
            setIsDrawerOpen(false);
        }
    };

    const initialValues: any = {
        name: homeProps?.name || '',
        order: homeProps?.order || '',
        active: { value: homeProps?.active === false ? 'false' : 'true', label: '' },
        type: { value: homeProps?.type, label: '' },
        date: homeProps ? [convertToDayjs(homeProps?.initialDate), convertToDayjs(homeProps?.finalDate)] : '',
        banners: homeProps ? { value: homeProps?.banners && homeProps?.banners[0]?.uuid, label: homeProps?.banners && homeProps?.banners[0]?.nameTag } : '',
        category: homeProps ? { value: homeProps?.category?.uuid, label: homeProps?.category?.categoryName } : '',
        mobile: { value: homeProps?.mobile === false ? 'false' : 'true', label: homeProps?.mobile === false ? 'Não' : 'Sim' },
    };

    return (
        <Formik
            validationSchema={typeSelected != "BANNER_CAROUSEL" ? validationSchemaCategory : validationSchemaBanner}
            initialValues={initialValues} onSubmit={async (values, { resetForm }) => {
                await handleSubmit(values);
                resetForm()
            }}
            enableReinitialize>
            {({ submitForm, resetForm }) => (
                <Drawer
                    title="Editação de Componente"
                    width={450}
                    onClose={() => {
                        resetForm(); // Reseta o formulário ao fechar
                        setIsDrawerOpen(false);
                    }}
                    open={isModalDrawer}
                    footer={
                        <div className="flex gap-4 justify-end">
                            <Button onClick={() => setIsDrawerOpen(false)}>Cancelar</Button>
                            <Button type="primary" onClick={submitForm}>
                                Cadastrar
                            </Button>
                        </div>
                    }
                >
                    <Form>
                        <div className="flex flex-col gap-2">
                            <InputComponent size="middle" label="Nome" name="name" id="name" />
                            <SelectComponent size="middle" label="Ativo" name="active" id="active" options={YesOrNot} />
                            <SelectComponent size="middle" label="Responsivo" name="mobile" id="mobile" options={YesOrNot} />
                            <InputNumberComponente size="middle" label="Ordenação" name="order" id="order" />
                            <SelectComponent disabled={true} size="middle" onChange={(value, option) => setTypeSelected(option)} label="Tipo" name="type" options={ComponentesSelect} />
                            <DatePickerRangeComponet size="middle" label="Data Inicial e Final" name="date" />

                            {typeSelected && typeSelected === "PRODUCT_CAROUSEL" &&
                                <Permission permissionKeys={[PermissionCategories.GET]} inputType name="Categoria">
                                    <SelectComponent size="middle" label="Categoria" name="category" options={selectCategory} />
                                </Permission>
                            }

                            {typeSelected && typeSelected != "PRODUCT_CAROUSEL" &&
                                <Permission permissionKeys={[PermissionBanners.GET]} inputType name="Banners">
                                    <SelectComponent size="middle" label="Banners" name="banners" options={bannerListSelected} />
                                </Permission>
                            }
                        </div>
                    </Form>
                </Drawer>
            )}
        </Formik>
    );
});

export default DrawerComponent;
